import { render, staticRenderFns } from "./ModalConfirmationPecas.vue?vue&type=template&id=53f8a66c"
import script from "./ModalConfirmationPecas.vue?vue&type=script&lang=js"
export * from "./ModalConfirmationPecas.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmationPecas.vue?vue&type=style&index=0&id=53f8a66c&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports